import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, type ButtonProps } from '@mui/material';
import { CheckOutlined } from '@mui/icons-material';

export const ApplyButton: FC<ButtonProps> = ({ children, ...props }) => {
  const { t } = useTranslation();

  return (
    <Button variant="contained" startIcon={<CheckOutlined />} {...props}>
      {children ?? t('Apply')}
    </Button>
  );
};
